var Journey = (function ($) {
  // ### Selectors
  var _s = {
    journey: ".chm-block-journey",
    journeyPath: ".chm-block-journey-path",
    journeyPathPreview: ".chm-block-journey-path__preview",
    journeyPathView: ".chm-block-journey-path__view",
    journeyPathPreview_description: ".chm-block-journey-path__preview__description",
    journeyPathTrigger: ".js-journeyPathTrigger",
    journeyPathUntrigger: ".js-journeyPathUntrigger",
    gFormSubmitButton: '.gform_button[type="submit"]',
    participationSelf: ".participation_self",
    over65Self: ".over_65_self",
    programSelf: ".program_self",
    chmPlusSelf: ".chm_plus_self",
    participationSpouse: ".participation_spouse",
    over65Spouse: ".over_65_spouse",
    programSpouse: ".program_spouse",
    chmPlusSpouse: ".chm_plus_spouse"
  };

  // ### Init
  var _init = function () {
    _bindEvents();
  };

  // ### Bind Events
  var _bindEvents = function () {
    // Choose Path
    let DL_journeyPath1_clicked = false;
    let DL_journeyPath2_clicked = false;
    $(_s.journeyPathTrigger).on("click", function () {
      let $this = $(this);

      let activeJourneyPath = null;
      let inactiveJourneyPath = null;

      if ($this.parents(_s.journeyPath).is(":nth-child(2)")) {
        $this.parents(_s.journey + "__inner").addClass("transition-1");
        activeJourneyPath = $this.parents(_s.journeyPath);
        inactiveJourneyPath = $(_s.journeyPath).not(activeJourneyPath);

        // console.log(activeJourneyPath.offset());

        if (!DL_journeyPath1_clicked) {
          // Button click event
          dataLayer.push({
            event: "fyp_button_click",
            tool_name: "find_your_program",
            engagement_type: "fyp_tool_select",
          });
          // Tool start event
          dataLayer.push({
            tool_name: "find_your_program",
            engagement_type: "tool_start",
            event: "tool_engagement",
          });
          DL_journeyPath1_clicked = true;
        }
      } else if ($this.parents(_s.journeyPath).is(":last-child")) {
        $this.parents(_s.journey + "__inner").addClass("transition-2");
        activeJourneyPath = $this.parents(_s.journeyPath);
        inactiveJourneyPath = $(_s.journeyPath).not(activeJourneyPath);

        // console.log(activeJourneyPath.offset());

        if (!DL_journeyPath2_clicked) {
          // Button click event
          dataLayer.push({
            event: "fyp_button_click",
            tool_name: "cost_calculator",
            engagement_type: "fyp_tool_select",
          });
          // Tool start event
          dataLayer.push({
            tool_name: "cost_calculator",
            engagement_type: "tool_start",
            event: "tool_engagement",
          });
          DL_journeyPath2_clicked = true;
        }
      } else {
        // Button click event
        dataLayer.push({
          event: "fyp_button_click",
          tool_name: "cost_comparison",
          engagement_type: "fyp_tool_select",
        });
        // Cost Comparison Tool starts on its own page
        return;
      }

      $(_s.journeyPath).removeClass("active");
      if (activeJourneyPath) {
        activeJourneyPath.find(_s.journeyPathPreview).fadeOut(700);
      }
      inactiveJourneyPath.find(_s.journeyPathPreview_description).slideUp(300);
      inactiveJourneyPath.find(_s.journeyPathView).fadeOut(300);

      setTimeout(function () {
        // Inactive Journey Path Preview
        inactiveJourneyPath.removeClass("active");
        inactiveJourneyPath.find(_s.journeyPathPreview).fadeIn(300);

        // Show Active Journey Path View
        if (activeJourneyPath) {
          activeJourneyPath.find(_s.journeyPathView).slideDown(300);
          activeJourneyPath.addClass("active");
        }
        $this.parents(_s.journey + "__inner").removeClass("transition-1 transition-2");

        $("html, body")
          .stop()
          .animate(
            {
              scrollTop: activeJourneyPath.offset().top - 220,
            },
            800
          );

        // * Special for Cost Calculator * //
        if (!activeJourneyPath.find(".chm-block-cost-calculator .table__collapsible").hasClass("active")) {
          setTimeout(function () {
            activeJourneyPath.find(".chm-block-cost-calculator .table__collapsible-trigger").trigger("click");
          }, 600);
        }
      }, 700);
    });

    // Unchoose Path
    $(_s.journeyPathUntrigger).on("click", function () {
      $(_s.journeyPath).removeClass("active");
      $(_s.journeyPathView).fadeOut(300);

      setTimeout(function () {
        $(_s.journeyPathPreview).fadeIn(300);
        $(_s.journeyPathPreview).children().slideDown(300);
      }, 700);
    });

    $(document).on('gform_page_loaded', function(event, form_id, current_page){
      // Find Your Program form submission event
      // pushing data events on form submission so they're only sent once, with final values
      // Self selections
      $(_s.gFormSubmitButton).on('click', function() {
        const participationSelf = $("input[type='radio']:checked", _s.participationSelf).val();
        if (participationSelf === "Yes") {
          const person = "self";
          const age_over_65 = $("input[type='radio']:checked", _s.over65Self).val();
          const programSelf = $("input[type='radio']:checked", _s.programSelf).val();
          const program = programSelf.split('|')[0];
          const chmPlusSelf = $("input[type='radio']:checked", _s.chmPlusSelf).val();
          const chm_plus = chmPlusSelf.split('|')[0];
          dataLayer.push({
            event: 'tool_engagement',
            tool_name: "find_your_program",
            engagement_type: "self_selection",
            person,
            age_over_65,
            program,
            chm_plus
          });
        }
        // Spouse selections
        const participationSpouse = $("input[type='radio']:checked", _s.participationSpouse).val();
        if (participationSpouse === "Yes") {
          const person = "spouse";
          const age_over_65 = $("input[type='radio']:checked", _s.over65Spouse).val();
          const programSpouse = $("input[type='radio']:checked", _s.programSpouse).val();
          const program = programSpouse.split('|')[0];
          const chmPlusSpouse = $("input[type='radio']:checked", _s.chmPlusSpouse).val();
          const chm_plus = chmPlusSpouse.split('|')[0];
          dataLayer.push({
            event: 'tool_engagement',
            tool_name: "find_your_program",
            engagement_type: "spouse_selection",
            person,
            age_over_65,
            program,
            chm_plus
          });
        }

        // Tool complete
        dataLayer.push({
          event: 'tool_complete',
          tool_name: "find_your_program",
          engagement_type: "tool_complete",
        });
      });
    });

  };

  return {
    init: _init,
  };
})(jQuery);
